import { z } from "zod";

export const RecoverPasswordFormSchema = z
  .object({
    phone: z.string().regex(/^55\d{11}$/, {
      message: "WhatsApp inválido",
    }),
    newPassword: z.string().min(1, { message: "Senha inválida" }),
    confirmNewPassword: z.string().min(1, { message: "Senha inválida" }),
    securityCode: z
      .string()
      .min(6, { message: "Código inválido" })
      .max(6, { message: "Código inválido" }),
  })
  .refine((data) => data.newPassword === data.confirmNewPassword, {
    message: "As senhas devem ser iguais",
    path: ["confirmNewPassword"],
  });
